import React from "react";
import PropTypes from "prop-types";
import { BQLink } from "../../../../atoms/bqlink";
import "./research-report-card.m.css";
import { FourStarIcon } from "../../../../atoms/material-icons";

const ResearchReportCard = ({ report, onClickDl }) => (
  <div styleName="wrapper" className="card-with-reaction-title" onClick={onClickDl}>
    <div styleName="author-name">
      {report?.["author_byline"]}
      <span className="exclusive-icon">
        <FourStarIcon color="#CE9445" size="16px" />
      </span>
    </div>
    <h3>
      <BQLink href={new URL(report?.link).pathname}>
        <div styleName="headline">{report?.title}</div>
      </BQLink>
    </h3>
  </div>
);

ResearchReportCard.propTypes = {
  report: PropTypes.object.isRequired,
};

export default ResearchReportCard;
